function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Path");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Telas-Incendio-Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Emiss\\xE3o-Full-Page",
  transform: "translate(-332.000000, -842.000000)",
  fill: "#FF6414",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-8-Copy",
  transform: "translate(289.000000, 808.600000)"
}, React.createElement("g", {
  id: "Group-21"
}, React.createElement("path", {
  d: "M53.2857143,45.3787769 L53.2857143,44.3337926 C54.7019286,43.5473611 55.8571429,41.5854015 55.8571429,39.6240757 C55.8571429,36.4739139 55.8571429,33.9207048 52,33.9207048 C48.1428571,33.9207048 48.1428571,36.4739139 48.1428571,39.6240757 C48.1428571,41.5860352 49.2980714,43.5473611 50.7142857,44.3337926 L50.7142857,45.3787769 C46.3531429,45.7304847 43,47.8426331 43,50.3964758 L61,50.3964758 C61,47.8426331 57.6468571,45.729851 53.2857143,45.3787769 Z",
  id: "Path"
})))));

var SvgUserInsured = function SvgUserInsured(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "17px",
    viewBox: "0 0 18 17",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgUserInsured, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user_insured.9a33e026.svg";
export { ForwardRef as ReactComponent };